// extracted by mini-css-extract-plugin
export default {"asked_questions":"styles_asked_questions__49hxQ"};